import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddCarnivalThroughStage from "./addCarnivalThroughStage";
import {
  saveCarnival,
  getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  leadInfraId: state.ConductCampReducer.leadInfraId,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  latlng: state.currentLocationReducer.latlng,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getLeadInfraId,
      saveCarnival,
      locationArea,
      locationCity,
      locationPinCode,
      locationState,
      locationType,
      locationZone,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddCarnivalThroughStage);
